export default class SendWorkerRequest  { 
    jobWorkerIds: string[] = [];
    emailBccUser = true;	
}
